"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerInfo = void 0;
var React = require("react");
var components_1 = require("../components");
var PodcastPlayerInfo = function (_a) {
    var title = _a.title, link = _a.link, audioRef = _a.audioRef, isPlaying = _a.isPlaying, currentTime = _a.currentTime, duration = _a.duration, setCurrentTime = _a.setCurrentTime, isMobile = _a.isMobile;
    var handleSeek = function (event) {
        var newTime = +event.target.value;
        var audio = audioRef.current;
        if (audio && newTime !== currentTime) {
            audio.currentTime = newTime;
            setCurrentTime(newTime);
        }
    };
    var formatTime = function (time) {
        var minutes = Math.floor(time / 60);
        var seconds = Math.floor(time % 60);
        // eslint-disable-next-line sonarjs/no-nested-template-literals
        return minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
    };
    return (React.createElement("div", { className: "podcast-player-info" },
        React.createElement("a", { href: link, className: "podcast-player-info__link", target: "_blank", rel: "noreferrer" },
            React.createElement("h3", { className: "podcast-player-info__title" }, isMobile ? React.createElement(components_1.PodcastPlayerMobileTitle, { title: title, isRunning: isPlaying }) : title)),
        React.createElement("input", { className: "podcast-player-info__play-progress", type: "range", value: currentTime, max: duration, onChange: handleSeek }),
        React.createElement("div", { className: "podcast-player-info__timings" },
            React.createElement("p", null, formatTime(currentTime)),
            React.createElement("p", null, formatTime(duration)))));
};
exports.PodcastPlayerInfo = PodcastPlayerInfo;
